import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { InputText } from "primereact/inputtext";
import { RadioButton } from "primereact/radiobutton";
import React, { useEffect, useRef, useState } from "react";
import { Button } from "primereact/button";
import { convertEpochtoDate } from "../../../../helper/DateConverters";
import { defaultFormValues } from "./defaultFormvalues";
import PhotoUpload from "../Vehicle-assessment/PhotoUpload/photoUpload";
import { showError, showSuccess } from "../../../../util/ShowStatus";
import { Toast } from "primereact/toast";
import axios from "../../../../util/axiosconfig";
import { getErrorMessage } from "../../../../helper/getResponseMessage";
import { useNavigate } from "react-router-dom";
import { Image } from "primereact/image";

const AddConfinedSpacesEquipment = ({
  formValues,
  setFormValues,
  setShowConfinedSpacesEquipmentFormPopup,
  isUploadInProgress,
  setIsUploadInProgress,
  isConfinedSpaceFormAttached,
  showAttachedFiles,
  fileValues,
  setFileValues,
  showTimeStampLocations,
  confinedImages,
  setConfinedImages,
}: any) => {
  const toast = useRef<Toast>(null);
  const navigate = useNavigate();
  const [localFormValues, setLocalFormValues] = useState(defaultFormValues);
  const [formSubmitting, setFormSubmitting] = useState(false);
  const [isConfinedSpaceUploadInProgress, setIsConfinedSpaceUploadInProgress] =
    useState(false);
  const [localFileValues, setLocalFileValues] = useState<any[]>([]);
  const ImageNotAvailable = process.env.REACT_APP_IMAGE_NOT_FOUND_URL || "";
  const [localImages, setLocalImages] = useState<Record<string, File>>({});
  // const [localTimeStampLocationValues, setLocalTimeStampLocationValues] =
  //   useState({
  //     locations: [],
  //     timeStamps: [],
  //   });
  const icon = (
    <i
      className="pi pi-eye tw-text-white tw-h-full tw-w-full tw-justify-center tw-items-center tw-flex"
      style={{
        backgroundColor: "black",
        opacity: 0.5,
        transition: "opacity 0.3s ease",
      }}
    ></i>
  );

  const isDisabled =
    formSubmitting ||
    isUploadInProgress ||
    isConfinedSpaceUploadInProgress ||
    isConfinedSpaceFormAttached;

  const isStandaloneMode = formValues === undefined || formValues === null;

  const currentFormValues = isStandaloneMode ? localFormValues : formValues;

  const currentSetFormValues = isStandaloneMode
    ? setLocalFormValues
    : setFormValues;
  const currentFileValues =
    fileValues !== undefined ? fileValues : localFileValues;
  const currentSetFileValues =
    setFileValues !== undefined ? setFileValues : setLocalFileValues;
  const currentImages =
    confinedImages !== undefined ? confinedImages : localImages;
  const currentSetImages =
    setConfinedImages !== undefined ? setConfinedImages : setLocalImages;
  useEffect(() => {
    if (
      !isStandaloneMode &&
      !formValues &&
      typeof setFormValues === "function"
    ) {
      setFormValues(defaultFormValues);
    }
  }, [formValues, setFormValues, isStandaloneMode]);

  const safeSetFormValues = (updater: any) => {
    if (typeof currentSetFormValues === "function") {
      currentSetFormValues(updater);
    }
  };

  const safeSetFileValues = (updater: any) => {
    if (typeof currentSetFileValues === "function") {
      currentSetFileValues(updater);
    }
  };

  const safeSetImages = (updater: any) => {
    if (typeof currentSetImages === "function") {
      currentSetImages(updater);
    }
  };

  const [timeStampLocationValues, setTimeStampLocationValues] = useState({
    locations: [],
    timeStamps: [],
  });

  // Helper to get equipment photo by label
  const getEquipmentPhoto = (label: string) => {
    const photo =
      showAttachedFiles?.equipmentPhotos &&
      showAttachedFiles?.equipmentPhotos?.find((img: any) =>
        img.originalname
          .replace(".png", "")
          .toLowerCase()
          .includes(label.toLowerCase())
      );
    return photo?.file || ImageNotAvailable;
  };

  // Helper to get timestamp and location by photoKey
  const getPhotoMeta = (photoKey: string) => {
    const locationObj = showTimeStampLocations?.locations?.find(
      (loc: any) => loc.photoKey === photoKey
    );
    const timeObj = showTimeStampLocations?.timeStamps?.find(
      (t: any) => t.photoKey === photoKey
    );
    return {
      address: locationObj?.address || "",
      timestamp: timeObj?.timestamp || "",
    };
  };

  const validateForm = () => {
    if (!currentFormValues?.site || currentFormValues?.site.trim() === "") {
      showError("Site Value is required", toast);
      return false;
    }
    if (
      !currentFormValues?.completedBy?.userID ||
      !currentFormValues?.completedBy?.displayName
    ) {
      showError("Completed By is required", toast);
      return false;
    }
    if (!currentFormValues?.date) {
      showError("Date is required", toast);
      return false;
    }

    const tripodChecklistUnselected = currentFormValues?.tripodChecklist?.some(
      (item: any) => !item.value
    );
    if (tripodChecklistUnselected) {
      showError(
        "Please select Yes/No/N/A for all Tripod Checklist items.",
        toast
      );
      return false;
    }

    const winchChecklistUnselected = currentFormValues?.winchChecklist?.some(
      (item: any) => !item.value
    );
    if (winchChecklistUnselected) {
      showError(
        "Please select Yes/No/N/A for all Winch Checklist items.",
        toast
      );
      return false;
    }

    const safetyHarnessChecklistUnselected =
      currentFormValues?.safetyHarnessChecklist?.some(
        (item: any) => !item.value
      );
    if (safetyHarnessChecklistUnselected) {
      showError(
        "Please select Yes/No/N/A for all Safety Harness Checklist items.",
        toast
      );
      return false;
    }

    const connectorsChecklistUnselected =
      currentFormValues?.connectorsChecklist?.some((item: any) => !item.value);
    if (connectorsChecklistUnselected) {
      showError(
        "Please select Yes/No/N/A for all Connectors Checklist items.",
        toast
      );
      return false;
    }

    const gasMonitorChecklistUnselected =
      currentFormValues?.gasMonitorChecklist?.some((item: any) => !item.value);
    if (gasMonitorChecklistUnselected) {
      showError(
        "Please select Yes/No/N/A for all Gas Monitor Checklist items.",
        toast
      );
      return false;
    }

    if (
      !currentFileValues.some(
        (file: any) =>
          file.photoKey && file.photoKey.toLowerCase().includes("tripos")
      )
    ) {
      showError("Please upload the Tripos photograph.", toast);
      return false;
    }
    if (
      !currentFileValues.some(
        (file: any) =>
          file.photoKey && file.photoKey.toLowerCase().includes("winch")
      )
    ) {
      showError("Please upload the Winch photograph.", toast);
      return false;
    }
    if (
      !currentFileValues.some(
        (file: any) =>
          file.photoKey && file.photoKey.toLowerCase().includes("harness")
      )
    ) {
      showError("Please upload the Harness photograph.", toast);
      return false;
    }
    if (
      !currentFileValues.some(
        (file: any) =>
          file.photoKey && file.photoKey.toLowerCase().includes("gas_monitors")
      )
    ) {
      showError("Please upload the Gas Monitors photograph.", toast);
      return false;
    }
    if (
      !currentFileValues.some(
        (file: any) =>
          file.photoKey && file.photoKey.toLowerCase().includes("connectors")
      )
    ) {
      showError("Please upload the Connectors photograph.", toast);
      return false;
    }

    return true; // Return true if valid, false otherwise
  };

  const handleSave = async () => {
    // Logic to save the form data
    try {
      if (!validateForm()) {
        return;
      }
      setFormSubmitting(true);
      setIsUploadInProgress && setIsUploadInProgress(true);
      setIsConfinedSpaceUploadInProgress(true);
      // Prepare FormData
      const formData = new FormData();

      // 1. Process signatures
      const photosArray: File[] = [];

      // Process additional team members signatures
      currentFileValues.forEach((photoItem: any) => {
        if (photoItem?.photoKey && photoItem?.file) {
          const fileName = `${photoItem.photoKey}.png`;
          const dataURL = new Blob([photoItem.file], {
            type: "image/png",
          });
          const photoFile = new File([dataURL], fileName, {
            type: "image/png",
          });
          photosArray.push(photoFile);
        }
      });

      photosArray.forEach((file, index) => {
        formData.append("equipmentPhotos", file);
      });

      formData.append("formJson", JSON.stringify(currentFormValues));
      formData.append(
        "timeStampLocationJson",
        JSON.stringify(timeStampLocationValues)
      );
      formData.append("isWeb", "true");

      const response = await axios.post(
        "health-and-safety/pre-use-confined-space-equipment-form",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      setFormSubmitting(false);
      showSuccess(response.data.Message, toast);
      setIsUploadInProgress && setIsUploadInProgress(false);
      setIsConfinedSpaceUploadInProgress(false);
      navigate("/layout/health-and-safety/pre-use-confined-space-equipment");
    } catch (error) {
      const errorMessage = getErrorMessage(error);
      setIsUploadInProgress && setIsUploadInProgress(false);
      setIsConfinedSpaceUploadInProgress(false);
      setFormSubmitting(false);
      showError(errorMessage, toast);
    }
  };

  return (
    <React.Fragment>
      <Toast ref={toast} />
      <div className="form-border">
        {isStandaloneMode && (
          <div className="form-header-border">
            <h2 className="form-header-h2">
              Confined Spaces Equipment Checklist
            </h2>
          </div>
        )}
        <div>
          <div className="tw-p-2 sm:tw-p-4">
            <div className="tw-grid tw-grid-cols-1  2xl:tw-grid-cols-3 tw-gap-6 tw-w-full tw-mt-4">
              <div className="tw-flex tw-flex-col tw-gap-1 tw-items-start tw-justify-start">
                <label className="leak-label" htmlFor="teamMember1">
                  Site
                </label>
                <InputText
                  value={currentFormValues?.site || ""}
                  onChange={(e) =>
                    safeSetFormValues((prev: any) => ({
                      ...prev,
                      site: e.target.value,
                    }))
                  }
                  readOnly={isDisabled}
                  type="text"
                  className="tw-pl-2 tw-border tw-border-gray-300 tw-rounded-md tw-text-[#667085] tw-h-11 tw-w-full"
                />
              </div>
              <div className="tw-flex tw-flex-col tw-gap-1 tw-items-start tw-justify-start">
                <label className="leak-label" htmlFor="teamMember1">
                  Completed By
                </label>
                <InputText
                  value={localStorage.displayName ?? ""}
                  readOnly
                  type="text"
                  className="tw-pl-2 tw-border tw-border-gray-300 tw-rounded-md tw-text-[#667085] tw-h-11 tw-w-full"
                />
              </div>
              <div className="tw-flex tw-flex-col tw-gap-1 tw-items-start tw-justify-start">
                <label className="leak-label" htmlFor="teamMember1">
                  Date
                </label>
                <InputText
                  readOnly
                  value={convertEpochtoDate(currentFormValues?.date) || ""}
                  type="text"
                  className="tw-pl-2 tw-border tw-border-gray-300 tw-rounded-md tw-text-[#667085] tw-h-11 tw-w-full"
                />
              </div>
            </div>
            <div>
              <DataTable
                value={currentFormValues?.tripodChecklist || []}
                className="tw-mt-6"
                scrollable
                showGridlines
              >
                <Column
                  field="label"
                  header="TRIPOD  "
                  style={{ maxWidth: "500px" }}
                />
                <Column
                  field="yes"
                  header="Yes"
                  style={{ maxWidth: "100px" }}
                  body={(rowData, { rowIndex }) => (
                    <RadioButton
                      checked={
                        currentFormValues?.tripodChecklist[rowIndex].value ===
                        "yes"
                      }
                      disabled={isDisabled}
                      name={`yes-${rowIndex}`}
                      inputId={`yes-${rowIndex}`}
                      className="tw-mr-2"
                      onChange={() =>
                        safeSetFormValues((prev: any) => ({
                          ...prev,
                          tripodChecklist: prev.tripodChecklist.map(
                            (item: any, index: number) =>
                              index === rowIndex
                                ? { ...item, value: "yes" }
                                : item
                          ),
                        }))
                      }
                    />
                  )}
                />
                <Column
                  field="no"
                  header="No"
                  style={{ maxWidth: "100px" }}
                  body={(rowData, { rowIndex }) => (
                    <RadioButton
                      checked={
                        currentFormValues?.tripodChecklist[rowIndex].value ===
                        "no"
                      }
                      disabled={isDisabled}
                      name={`no-${rowIndex}`}
                      inputId={`no-${rowIndex}`}
                      className="tw-mr-2"
                      onChange={() =>
                        safeSetFormValues((prev: any) => ({
                          ...prev,
                          tripodChecklist: prev.tripodChecklist.map(
                            (item: any, index: number) =>
                              index === rowIndex
                                ? { ...item, value: "no" }
                                : item
                          ),
                        }))
                      }
                    />
                  )}
                />
                <Column
                  field="n_a"
                  header="N/A"
                  style={{ maxWidth: "100px" }}
                  body={(rowData, { rowIndex }) => (
                    <RadioButton
                      checked={
                        currentFormValues?.tripodChecklist[rowIndex].value ===
                        "n_a"
                      }
                      disabled={isDisabled}
                      name={`n_a-${rowIndex}`}
                      inputId={`n_a-${rowIndex}`}
                      className="tw-mr-2"
                      onChange={() =>
                        safeSetFormValues((prev: any) => ({
                          ...prev,
                          tripodChecklist: prev.tripodChecklist.map(
                            (item: any, index: number) =>
                              index === rowIndex
                                ? { ...item, value: "n_a" }
                                : item
                          ),
                        }))
                      }
                    />
                  )}
                />
              </DataTable>
              <DataTable
                value={currentFormValues?.winchChecklist || []}
                className="tw-mt-6"
                scrollable
                showGridlines
              >
                <Column
                  field="label"
                  header="WINCH "
                  style={{ maxWidth: "500px" }}
                />
                <Column
                  field="yes"
                  header="Yes"
                  style={{ maxWidth: "100px" }}
                  body={(rowData, { rowIndex }) => (
                    <RadioButton
                      checked={
                        currentFormValues?.winchChecklist[rowIndex].value ===
                        "yes"
                      }
                      disabled={isDisabled}
                      name={`yes-${rowIndex}`}
                      inputId={`yes-${rowIndex}`}
                      className="tw-mr-2"
                      onChange={() =>
                        safeSetFormValues((prev: any) => ({
                          ...prev,
                          winchChecklist: prev.winchChecklist.map(
                            (item: any, index: number) =>
                              index === rowIndex
                                ? { ...item, value: "yes" }
                                : item
                          ),
                        }))
                      }
                    />
                  )}
                />
                <Column
                  field="no"
                  header="No"
                  style={{ maxWidth: "100px" }}
                  body={(rowData, { rowIndex }) => (
                    <RadioButton
                      checked={
                        currentFormValues?.winchChecklist[rowIndex].value ===
                        "no"
                      }
                      disabled={isDisabled}
                      name={`no-${rowIndex}`}
                      inputId={`no-${rowIndex}`}
                      className="tw-mr-2"
                      onChange={() =>
                        safeSetFormValues((prev: any) => ({
                          ...prev,
                          winchChecklist: prev.winchChecklist.map(
                            (item: any, index: number) =>
                              index === rowIndex
                                ? { ...item, value: "no" }
                                : item
                          ),
                        }))
                      }
                    />
                  )}
                />
                <Column
                  field="n_a"
                  header="N/A"
                  style={{ maxWidth: "100px" }}
                  body={(rowData, { rowIndex }) => (
                    <RadioButton
                      checked={
                        currentFormValues?.winchChecklist[rowIndex].value ===
                        "n_a"
                      }
                      disabled={isDisabled}
                      name={`n_a-${rowIndex}`}
                      inputId={`n_a-${rowIndex}`}
                      className="tw-mr-2"
                      onChange={() =>
                        safeSetFormValues((prev: any) => ({
                          ...prev,
                          winchChecklist: prev.winchChecklist.map(
                            (item: any, index: number) =>
                              index === rowIndex
                                ? { ...item, value: "n_a" }
                                : item
                          ),
                        }))
                      }
                    />
                  )}
                />
              </DataTable>
              <DataTable
                value={currentFormValues?.safetyHarnessChecklist || []}
                className="tw-mt-6"
                scrollable
                showGridlines
              >
                <Column
                  field="label"
                  header="SAFETY HARNESSES   "
                  style={{ maxWidth: "500px" }}
                />
                <Column
                  field="yes"
                  header="Yes"
                  style={{ maxWidth: "100px" }}
                  body={(rowData, { rowIndex }) => (
                    <RadioButton
                      checked={
                        currentFormValues?.safetyHarnessChecklist[rowIndex]
                          .value === "yes"
                      }
                      disabled={isDisabled}
                      name={`yes-${rowIndex}`}
                      inputId={`yes-${rowIndex}`}
                      className="tw-mr-2"
                      onChange={() =>
                        safeSetFormValues((prev: any) => ({
                          ...prev,
                          safetyHarnessChecklist:
                            prev.safetyHarnessChecklist.map(
                              (item: any, index: number) =>
                                index === rowIndex
                                  ? { ...item, value: "yes" }
                                  : item
                            ),
                        }))
                      }
                    />
                  )}
                />
                <Column
                  field="no"
                  header="No"
                  style={{ maxWidth: "100px" }}
                  body={(rowData, { rowIndex }) => (
                    <RadioButton
                      checked={
                        currentFormValues?.safetyHarnessChecklist[rowIndex]
                          .value === "no"
                      }
                      disabled={isDisabled}
                      name={`no-${rowIndex}`}
                      inputId={`no-${rowIndex}`}
                      className="tw-mr-2"
                      onChange={() =>
                        safeSetFormValues((prev: any) => ({
                          ...prev,
                          safetyHarnessChecklist:
                            prev.safetyHarnessChecklist.map(
                              (item: any, index: number) =>
                                index === rowIndex
                                  ? { ...item, value: "no" }
                                  : item
                            ),
                        }))
                      }
                    />
                  )}
                />
                <Column
                  field="n_a"
                  header="N/A"
                  style={{ maxWidth: "100px" }}
                  body={(rowData, { rowIndex }) => (
                    <RadioButton
                      checked={
                        currentFormValues?.safetyHarnessChecklist[rowIndex]
                          .value === "n_a"
                      }
                      disabled={isDisabled}
                      name={`n_a-${rowIndex}`}
                      inputId={`n_a-${rowIndex}`}
                      className="tw-mr-2"
                      onChange={() =>
                        safeSetFormValues((prev: any) => ({
                          ...prev,
                          safetyHarnessChecklist:
                            prev.safetyHarnessChecklist.map(
                              (item: any, index: number) =>
                                index === rowIndex
                                  ? { ...item, value: "n_a" }
                                  : item
                            ),
                        }))
                      }
                    />
                  )}
                />
              </DataTable>
              <DataTable
                value={currentFormValues?.connectorsChecklist || []}
                className="tw-mt-6"
                scrollable
                showGridlines
              >
                <Column
                  field="label"
                  header="CONNECTORS – INCLUDING KARABINERS, SNAP HOOKS AND TUBE NUT ETC.    "
                  style={{ maxWidth: "500px" }}
                />
                <Column
                  field="yes"
                  header="Yes"
                  style={{ maxWidth: "100px" }}
                  body={(rowData, { rowIndex }) => (
                    <RadioButton
                      checked={
                        currentFormValues?.connectorsChecklist[rowIndex]
                          .value === "yes"
                      }
                      name={`yes-${rowIndex}`}
                      inputId={`yes-${rowIndex}`}
                      className="tw-mr-2"
                      disabled={isDisabled}
                      onChange={() =>
                        safeSetFormValues((prev: any) => ({
                          ...prev,
                          connectorsChecklist: prev.connectorsChecklist.map(
                            (item: any, index: number) =>
                              index === rowIndex
                                ? { ...item, value: "yes" }
                                : item
                          ),
                        }))
                      }
                    />
                  )}
                />
                <Column
                  field="no"
                  header="No"
                  style={{ maxWidth: "100px" }}
                  body={(rowData, { rowIndex }) => (
                    <RadioButton
                      checked={
                        currentFormValues?.connectorsChecklist[rowIndex]
                          .value === "no"
                      }
                      disabled={isDisabled}
                      name={`no-${rowIndex}`}
                      inputId={`no-${rowIndex}`}
                      className="tw-mr-2"
                      onChange={() =>
                        safeSetFormValues((prev: any) => ({
                          ...prev,
                          connectorsChecklist: prev.connectorsChecklist.map(
                            (item: any, index: number) =>
                              index === rowIndex
                                ? { ...item, value: "no" }
                                : item
                          ),
                        }))
                      }
                    />
                  )}
                />
                <Column
                  field="n_a"
                  header="N/A"
                  style={{ maxWidth: "100px" }}
                  body={(rowData, { rowIndex }) => (
                    <RadioButton
                      checked={
                        currentFormValues?.connectorsChecklist[rowIndex]
                          .value === "n_a"
                      }
                      disabled={isDisabled}
                      name={`n_a-${rowIndex}`}
                      inputId={`n_a-${rowIndex}`}
                      className="tw-mr-2"
                      onChange={() =>
                        safeSetFormValues((prev: any) => ({
                          ...prev,
                          connectorsChecklist: prev.connectorsChecklist.map(
                            (item: any, index: number) =>
                              index === rowIndex
                                ? { ...item, value: "n_a" }
                                : item
                          ),
                        }))
                      }
                    />
                  )}
                />
              </DataTable>
              <DataTable
                value={currentFormValues?.gasMonitorChecklist || []}
                className="tw-mt-6"
                scrollable
                showGridlines
              >
                <Column
                  field="label"
                  header="GAS MONITOR "
                  style={{ maxWidth: "500px" }}
                />
                <Column
                  field="yes"
                  header="Yes"
                  style={{ maxWidth: "100px" }}
                  body={(rowData, { rowIndex }) => (
                    <RadioButton
                      checked={
                        currentFormValues?.gasMonitorChecklist[rowIndex]
                          .value === "yes"
                      }
                      disabled={isDisabled}
                      name={`yes-${rowIndex}`}
                      inputId={`yes-${rowIndex}`}
                      className="tw-mr-2"
                      onChange={() =>
                        safeSetFormValues((prev: any) => ({
                          ...prev,
                          gasMonitorChecklist: prev.gasMonitorChecklist.map(
                            (item: any, index: number) =>
                              index === rowIndex
                                ? { ...item, value: "yes" }
                                : item
                          ),
                        }))
                      }
                    />
                  )}
                />
                <Column
                  field="no"
                  header="No"
                  style={{ maxWidth: "100px" }}
                  body={(rowData, { rowIndex }) => (
                    <RadioButton
                      checked={
                        currentFormValues?.gasMonitorChecklist[rowIndex]
                          .value === "no"
                      }
                      disabled={isDisabled}
                      name={`no-${rowIndex}`}
                      inputId={`no-${rowIndex}`}
                      className="tw-mr-2"
                      onChange={() =>
                        safeSetFormValues((prev: any) => ({
                          ...prev,
                          gasMonitorChecklist: prev.gasMonitorChecklist.map(
                            (item: any, index: number) =>
                              index === rowIndex
                                ? { ...item, value: "no" }
                                : item
                          ),
                        }))
                      }
                    />
                  )}
                />
                <Column
                  field="n_a"
                  header="N/A"
                  style={{ maxWidth: "100px" }}
                  body={(rowData, { rowIndex }) => (
                    <RadioButton
                      checked={
                        currentFormValues?.gasMonitorChecklist[rowIndex]
                          .value === "n_a"
                      }
                      disabled={isDisabled}
                      name={`n_a-${rowIndex}`}
                      inputId={`n_a-${rowIndex}`}
                      className="tw-mr-2"
                      onChange={() =>
                        safeSetFormValues((prev: any) => ({
                          ...prev,
                          gasMonitorChecklist: prev.gasMonitorChecklist.map(
                            (item: any, index: number) =>
                              index === rowIndex
                                ? { ...item, value: "n_a" }
                                : item
                          ),
                        }))
                      }
                    />
                  )}
                />
              </DataTable>
            </div>
            <div className="tw-mt-10 tw-flex tw-justify-center tw-items-center tw-gap-2 tw-flex-col tw-text-red-600">
              <span className="tw-underline tw-font-bold tw-text-xl">
                DO NOT USE{" "}
              </span>
              <p className="tw-text-center text-sm tw-font-semibold">
                Any equipment that is faulty or you are unsure if it is safe for
                use.
              </p>
              <p className="tw-text-center text-sm tw-font-semibold">
                Only trained competent persons are permitted to use all Confined
                Spaces Equipment.
              </p>
            </div>
            <div className="tw-pt-4 tw-pb-2 tw-border-b-[1px] tw-border-[#E2E8F0] tw-mt-4 ">
              <h2 className="tw-text-lg tw-font-semibold tw-text-[#101828]">
                Please click pictures of equipment with their calibration date
              </h2>
            </div>
            {isConfinedSpaceFormAttached ? (
              <>
                <div className="tw-grid tw-grid-cols-1 lg:tw-grid-cols-2 xl:tw-grid-cols-3 tw-gap-6 tw-px-4 tw-py-4 ">
                  <div className="tw-flex tw-flex-col tw-items-start tw-gap-2 ">
                    <p className="leak-detail-label">Tripos</p>
                    <div>
                      <Image
                        src={getEquipmentPhoto("tripos")}
                        preview
                        alt={`Vehicle Photograph Tripos`}
                        className="tw-w-32 tw-shrink-0 tw-object-contain"
                        indicatorIcon={icon}
                        loading="lazy"
                        // downloadable
                        pt={{
                          rotateRightButton: { className: "tw-text-white" },
                          downloadButton: { className: "tw-text-white" },
                          rotateLeftButton: { className: "tw-text-white" },
                          zoomInButton: { className: "tw-text-white" },
                          zoomOutButton: { className: "tw-text-white" },
                          closeButton: { className: "tw-text-white" },
                        }}
                        onError={(e) => {
                          (e.target as HTMLImageElement).src =
                            ImageNotAvailable;
                        }}
                      />
                      {(getPhotoMeta("tripos").timestamp ||
                        getPhotoMeta("tripos").address) && (
                        <div className="tw-mt-2">
                          <p className="tw-text-sm tw-text-gray-900">
                            {getPhotoMeta("tripos").address}
                          </p>
                          <p className="tw-text-sm tw-text-gray-900">
                            {getPhotoMeta("tripos").timestamp}
                          </p>
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="tw-flex tw-flex-col tw-items-start tw-gap-2 ">
                    <p className="leak-detail-label">Winch</p>
                    <div>
                      <Image
                        src={getEquipmentPhoto("winch")}
                        preview
                        alt={`Vehicle Photograph Winch`}
                        className="tw-w-32 tw-shrink-0 tw-object-contain"
                        indicatorIcon={icon}
                        loading="lazy"
                        // downloadable
                        pt={{
                          rotateRightButton: { className: "tw-text-white" },
                          downloadButton: { className: "tw-text-white" },
                          rotateLeftButton: { className: "tw-text-white" },
                          zoomInButton: { className: "tw-text-white" },
                          zoomOutButton: { className: "tw-text-white" },
                          closeButton: { className: "tw-text-white" },
                        }}
                        onError={(e) => {
                          (e.target as HTMLImageElement).src =
                            ImageNotAvailable;
                        }}
                      />
                      {(getPhotoMeta("winch").timestamp ||
                        getPhotoMeta("winch").address) && (
                        <div className="tw-mt-2">
                          <p className="tw-text-sm tw-text-gray-900">
                            {getPhotoMeta("winch").address}
                          </p>
                          <p className="tw-text-sm tw-text-gray-900">
                            {getPhotoMeta("winch").timestamp}
                          </p>
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="tw-flex tw-flex-col tw-items-start tw-gap-2 ">
                    <p className="leak-detail-label">Harness</p>
                    <div>
                      <Image
                        src={getEquipmentPhoto("harness")}
                        preview
                        alt={`Vehicle Photograph Harness`}
                        className="tw-w-32 tw-shrink-0 tw-object-contain"
                        indicatorIcon={icon}
                        loading="lazy"
                        // downloadable
                        pt={{
                          rotateRightButton: { className: "tw-text-white" },
                          downloadButton: { className: "tw-text-white" },
                          rotateLeftButton: { className: "tw-text-white" },
                          zoomInButton: { className: "tw-text-white" },
                          zoomOutButton: { className: "tw-text-white" },
                          closeButton: { className: "tw-text-white" },
                        }}
                        onError={(e) => {
                          (e.target as HTMLImageElement).src =
                            ImageNotAvailable;
                        }}
                      />
                      {(getPhotoMeta("harness").timestamp ||
                        getPhotoMeta("harness").address) && (
                        <div className="tw-mt-2">
                          <p className="tw-text-sm tw-text-gray-900">
                            {getPhotoMeta("harness").address}
                          </p>
                          <p className="tw-text-sm tw-text-gray-900">
                            {getPhotoMeta("harness").timestamp}
                          </p>
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="tw-flex tw-flex-col tw-items-start tw-gap-2 ">
                    <p className="leak-detail-label">Gas Monitors</p>
                    <div>
                      <Image
                        src={getEquipmentPhoto("gas_monitors")}
                        preview
                        alt={`Vehicle Photograph Gas Monitors`}
                        className="tw-w-32 tw-shrink-0 tw-object-contain"
                        indicatorIcon={icon}
                        loading="lazy"
                        // downloadable
                        pt={{
                          rotateRightButton: { className: "tw-text-white" },
                          downloadButton: { className: "tw-text-white" },
                          rotateLeftButton: { className: "tw-text-white" },
                          zoomInButton: { className: "tw-text-white" },
                          zoomOutButton: { className: "tw-text-white" },
                          closeButton: { className: "tw-text-white" },
                        }}
                        onError={(e) => {
                          (e.target as HTMLImageElement).src =
                            ImageNotAvailable;
                        }}
                      />
                      {(getPhotoMeta("gas_monitors").timestamp ||
                        getPhotoMeta("gas_monitors").address) && (
                        <div className="tw-mt-2">
                          <p className="tw-text-sm tw-text-gray-900">
                            {getPhotoMeta("gas_monitors").address}
                          </p>
                          <p className="tw-text-sm tw-text-gray-900">
                            {getPhotoMeta("gas_monitors").timestamp}
                          </p>
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="tw-flex tw-flex-col tw-items-start tw-gap-2 ">
                    <p className="leak-detail-label">Connectors </p>
                    <div>
                      <Image
                        src={getEquipmentPhoto("connectors")}
                        preview
                        alt={`Vehicle Photograph Connectors`}
                        className="tw-w-32 tw-shrink-0 tw-object-contain"
                        indicatorIcon={icon}
                        loading="lazy"
                        // downloadable
                        pt={{
                          rotateRightButton: { className: "tw-text-white" },
                          downloadButton: { className: "tw-text-white" },
                          rotateLeftButton: { className: "tw-text-white" },
                          zoomInButton: { className: "tw-text-white" },
                          zoomOutButton: { className: "tw-text-white" },
                          closeButton: { className: "tw-text-white" },
                        }}
                        onError={(e) => {
                          (e.target as HTMLImageElement).src =
                            ImageNotAvailable;
                        }}
                      />
                      {(getPhotoMeta("connectors").timestamp ||
                        getPhotoMeta("connectors").address) && (
                        <div className="tw-mt-2">
                          <p className="tw-text-sm tw-text-gray-900">
                            {getPhotoMeta("connectors").address}
                          </p>
                          <p className="tw-text-sm tw-text-gray-900">
                            {getPhotoMeta("connectors").timestamp}
                          </p>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </>
            ) : (
              <div className="tw-grid tw-grid-cols-1  lg:tw-grid-cols-5 tw-gap-6 tw-mt-6 ">
                <PhotoUpload
                  label={"Tripos"}
                  name="tripos"
                  images={currentImages}
                  isUploadInProgress={
                    (isUploadInProgress
                      ? isUploadInProgress
                      : isConfinedSpaceUploadInProgress) ||
                    isConfinedSpaceFormAttached
                  }
                  setIsUploadInProgress={
                    setIsUploadInProgress
                      ? setIsUploadInProgress
                      : setIsConfinedSpaceUploadInProgress
                  }
                  setImages={safeSetImages}
                  fileValues={currentFileValues}
                  setFileValues={safeSetFileValues}
                  timeStampLocationValues={timeStampLocationValues}
                  setTimeStampLocationValues={setTimeStampLocationValues}
                  classname="tw-w-full"
                />
                <PhotoUpload
                  label={"Winch"}
                  name="winch"
                  images={currentImages}
                  isUploadInProgress={
                    (isUploadInProgress
                      ? isUploadInProgress
                      : isConfinedSpaceUploadInProgress) ||
                    isConfinedSpaceFormAttached
                  }
                  setIsUploadInProgress={
                    setIsUploadInProgress
                      ? setIsUploadInProgress
                      : setIsConfinedSpaceUploadInProgress
                  }
                  setImages={safeSetImages}
                  fileValues={currentFileValues}
                  setFileValues={safeSetFileValues}
                  timeStampLocationValues={timeStampLocationValues}
                  setTimeStampLocationValues={setTimeStampLocationValues}
                  classname="tw-w-full"
                />
                <PhotoUpload
                  label={"Harness"}
                  name="harness"
                  images={currentImages}
                  isUploadInProgress={
                    (isUploadInProgress
                      ? isUploadInProgress
                      : isConfinedSpaceUploadInProgress) ||
                    isConfinedSpaceFormAttached
                  }
                  setIsUploadInProgress={
                    setIsUploadInProgress
                      ? setIsUploadInProgress
                      : setIsConfinedSpaceUploadInProgress
                  }
                  setImages={safeSetImages}
                  fileValues={currentFileValues}
                  setFileValues={safeSetFileValues}
                  timeStampLocationValues={timeStampLocationValues}
                  setTimeStampLocationValues={setTimeStampLocationValues}
                  classname="tw-w-full"
                />
                <PhotoUpload
                  label={"Gas Monitors"}
                  name="gas_monitors"
                  images={currentImages}
                  isUploadInProgress={
                    (isUploadInProgress
                      ? isUploadInProgress
                      : isConfinedSpaceUploadInProgress) ||
                    isConfinedSpaceFormAttached
                  }
                  setIsUploadInProgress={
                    setIsUploadInProgress
                      ? setIsUploadInProgress
                      : setIsConfinedSpaceUploadInProgress
                  }
                  setImages={safeSetImages}
                  fileValues={currentFileValues}
                  setFileValues={safeSetFileValues}
                  timeStampLocationValues={timeStampLocationValues}
                  setTimeStampLocationValues={setTimeStampLocationValues}
                  classname="tw-w-full"
                />
                <PhotoUpload
                  label={"Connectors"}
                  name="connectors"
                  images={currentImages}
                  isUploadInProgress={
                    (isUploadInProgress
                      ? isUploadInProgress
                      : isConfinedSpaceUploadInProgress) ||
                    isConfinedSpaceFormAttached
                  }
                  setIsUploadInProgress={
                    setIsUploadInProgress
                      ? setIsUploadInProgress
                      : setIsConfinedSpaceUploadInProgress
                  }
                  setImages={safeSetImages}
                  fileValues={currentFileValues}
                  setFileValues={safeSetFileValues}
                  timeStampLocationValues={timeStampLocationValues}
                  setTimeStampLocationValues={setTimeStampLocationValues}
                  classname="tw-w-full"
                />
              </div>
            )}
          </div>
          {isStandaloneMode && (
            <div className="tw-flex tw-justify-end tw-items-center tw-p-4  tw-gap-2 !tw-border-t-[#E2E8F0] tw-border-t-[1px]">
              <Button
                className="form-cancel-button"
                label="Cancel"
                disabled={isDisabled}
                onClick={() =>
                  setShowConfinedSpacesEquipmentFormPopup
                    ? setShowConfinedSpacesEquipmentFormPopup(false)
                    : navigate(
                        "/layout/health-and-safety/pre-use-confined-space-equipment"
                      )
                }
                color="white"
              />
              <Button
                className="tw-flex tw-px-3 focus:tw-shadow-none tw-py-2 tw-rounded tw-bg-primary tw-border-primary tw-text-white tw-font-medium"
                label={`${formSubmitting ? "Saving..." : "Save"}`}
                loading={formSubmitting}
                disabled={isDisabled}
                onClick={handleSave}
              />
            </div>
          )}
        </div>
      </div>
    </React.Fragment>
  );
};

export default AddConfinedSpacesEquipment;
